import { useAppState } from "../../context";
import { CategoryType } from "../../types";
import { Link } from "react-router";
import { FormattedText } from "../../utils/formatted-text";

export const CategoriesBlock = ({ title, text,  showDescriptions }: { title: string; text?: string; showDescriptions?: boolean }) => {
    const [categories] = useAppState<CategoryType[]>("categories", []);
    
    const categoriesWithImages = categories.filter((category) => category.image);

    if (categoriesWithImages.length === 0) {
        return null;
    }

    return (
        <section className="section s-cat">
            <div className="inside-wrapper">
                <h2 className="section__title">
                    {title}
                </h2>

                {text && (
                    <div className="section__text">
                        <FormattedText text={text} />
                    </div>
                )}

                <ul className="s-cat__list">
                    {categoriesWithImages.map((category, index) => (
                        <li key={index} className="s-cat__item">
                            <Link className="s-cat__link" to={`/catalog/${category.slug}`}>
                                <picture className="s-cat__pic">
                                    <source type="image/webp" srcSet={`/api/media/${category.image}?webp&s=s 1x, /api/media/${category.image}?webp&s=m 2x`} />
                                    <img 
                                        className="s-cat__img"
                                        src={`/api/media/${category.image}?s=s`}
                                        srcSet={`/api/media/${category.image}?s=m 2x`}
                                        alt=""
                                        width="405"
                                        height="143"
                                        loading="lazy"
                                    />
                                </picture>
                                <span className="s-cat__caption">
                                    <span className="s-cat__title">
                                        {category.name}
                                    </span>
                                    {showDescriptions && category.description && (
                                        <span className="s-cat__text">
                                            {category.description}
                                        </span>
                                    )}
                                </span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default CategoriesBlock;